import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';
import { Organisation } from '../../Models/Models/Customer/Organisation';
import { TrustRemovalReason } from '../../Constants/Enums/Customer/TrustRemovalReason';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class TrustMemberClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(organisation: Organisation): Promise<Array<ValidationStatus>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/TrustMember/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { organisation: organisation }

    return AjaxWrapper.post<Array<ValidationStatus>, any>(url, data);
  }
  public delete(organisation: Organisation, reasonType: TrustRemovalReason, deathTime: IJsonDate): Promise<Array<ValidationStatus>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/TrustMember/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { organisation: organisation, reasonType: reasonType, deathTime: deathTime }

    return AjaxWrapper.delete<Array<ValidationStatus>, any>(url, data);
  }
}

